import router, { asyncRouterMap } from './router';
import store from './store/store';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式
import _ from 'lodash';
import $ from 'jquery';
import introJs from 'intro.js';

router.beforeEach((to: any, from, next) => {
  // 首页不修改最小宽度
  if (to.path === '/' || to.path === '/index') {
    $('body').css({'min-width': '1260px'});
  } else {
    $('body').css({'min-width': '1460px'});
  }

  NProgress.start();
  introJs().exit();
  // 判断当前用户是否已拉取完user_info信息
  if (!store.getters.getUserInfo.accountType) {
    // 拉取info
    store.dispatch('setUserInfo').then((res: any) => {
      const accountType = store.getters.getUserInfo.accountType;
      const accessedRouters = asyncRouterMap.filter((route: any) => route.meta.role.indexOf(accountType) !== -1);
      // 动态添加可访问路由表
      router.addRoutes(accessedRouters);
      // 默认路由
      const defaultRoute = accessedRouters[0].path;
      store.dispatch('setDefaultRoute', defaultRoute);
      // 权限判断
      const authority = _.some(accessedRouters, (item: any) => {
        return item.path === to.path || item.alias === to.path;
      });
      // 如静态路由不为空，下面应为静态路由加动态路由
      // 是否是正确路由
      const isCorrectRoute = _.some(asyncRouterMap, (item: any) => {
        return item.path === to.path || item.alias === to.path;
      });
      if (authority) {
        store.dispatch('setMenuIndex', to.name);
        // hack方法 确保addRoutes已完成
        next({...to, replace: true});
      } else if (isCorrectRoute) {
        store.dispatch('setMenuIndex', defaultRoute.substr(1));
        // 跳转到默认路由
        next(defaultRoute);
      } else {
        store.dispatch('setMenuIndex', 'error');
        // 跳转到错误页面
        next('/error');
      }
    });
  } else {
    if (to.path === '/') {
      next('/paperCheck');
    } else {
      store.dispatch('setMenuIndex', to.name);
      // 当有用户权限的时候，说明所有可访问路由已生成
      next();
    }
  }
});
router.afterEach(() => {
  setTimeout(() => {
    NProgress.done();
  }, 800);
});
